import { type CommandHandler } from "@telespot/core";
import { type RoleRepository } from "@telespot/domain";

import { RevokeRoles } from "./revoke-roles.command";

export type IRevokeRoles = CommandHandler<RevokeRoles>;

/**
 * Errors thrown by {@link GrantRolesHandler}
 *
 * @group Authentication & Authorization
 * @category Errors
 */
export enum RevokeRoleErrors {
  ROLE_NOT_FOUND = "Role does not exist",
}

export class RevokeRolesHandler implements IRevokeRoles {

  constructor(private readonly roles: RoleRepository) { }

  public async execute(command: RevokeRoles) {
    const { userId, roles } = command.details;

    const existingRoles = await this.roles.list();

    const affectedRoles = existingRoles.filter(r => roles.includes(r.name));

    for (const name of roles) {
      const role = affectedRoles.find(r => r.name === name);

      if (!role) throw new Error(`${RevokeRoleErrors.ROLE_NOT_FOUND}: ${name}`);

      role.revokeFrom(userId);
    }

    await this.roles.save(affectedRoles);
  }
}
